import { createSelector } from 'reselect'

const getState = state => state.FSUEmailRequired

const getCurrentState = state => getState(state).state

const getEmailIdentityRequest = state =>
  getState(state).createEmailIdentityRequest

const getSendIdentityConnectRequest = state =>
  getState(state).sendIdentityConnectRequest

const getEmailIdentityError = createSelector(
  [getEmailIdentityRequest],
  req =>
    !req.requestError
      ? null
      : !req.requestError.response.data.errors
        ? 'unknown'
        : req.requestError.response.data.errors[0].err
)

export {
  getEmailIdentityRequest,
  getEmailIdentityError,
  getSendIdentityConnectRequest,
  getCurrentState
}
